import React from 'react'
import styled from 'styled-components'
import PopularBookResponse from './PopularBookResponse'
import IndexContentContainer from '../../index/IndexContentContainer'
import ColSpacer from '../../../common/styles/ColSpacer'
import ColorConfig from '../../../config/ColorConfig'
import BooksitoutImages from '../../../images/BooksitoutImages'
import RowSpacer from '../../../common/styles/RowSpacer'
import { BookStatus } from '../../book/BookType'
import { useNavigate } from 'react-router-dom'
import { Author } from '../../../common/Author'

interface Props {
	popularBook: PopularBookResponse
	colorType?: 'card' | 'card-card'
}

const PopularBookListRow: React.FC<Props> = ({ popularBook, colorType = 'card-card' }) => {
	const navigate = useNavigate()

	return (
		<IndexContentContainer href={`/book/${popularBook.isbn}?q=${popularBook.title}`} backgroundColorType={colorType}>
			<div className={'w-100'}>
				<ClickableOverlay
					clickable={!!popularBook.bookId}
					onClick={e => {
						e.preventDefault()
						// e.stopPropagation() div나 IndexContentContainer에 onClick 이벤트 줄 시 주석 해제
						popularBook.bookId && navigate(`/book/mine/${popularBook.bookId}`)
					}}
				/>
				<GlowCard status={popularBook.status} />
				<Row>
					<RankingBadge>{popularBook.ranking}</RankingBadge>
					<ColSpacer size={2.5} />

					<CoverContainer>
						<Cover src={popularBook.coverUrl ?? BooksitoutImages.Placeholder.bookCover} />
					</CoverContainer>

					<ColSpacer size={5} />

					<InfoContainer>
						<Title>{popularBook.title}</Title>
						<Author size={16}>{popularBook.author}</Author>

						<span className={'d-none d-sm-block'}>
							<RowSpacer size={2.5} />
							<PopularBookSourcesSection popularBook={popularBook} isStart={true} />
						</span>
					</InfoContainer>
				</Row>

				<span className={'d-block d-sm-none'}>
					<RowSpacer size={10} />
					<PopularBookSourcesSection popularBook={popularBook} isStart={false} />
				</span>
			</div>
		</IndexContentContainer>
	)
}

const PopularBookSourcesSection = ({ popularBook, isStart }) => {
	let justify = isStart ? `justify-content-start` : `justify-content-center`

	return (
		<div className={`d-flex ${justify} w-100`}>
			<div className={`d-flex ${justify} align-items-center force-1-line`} style={{ width: '70px' }}>
				<Logo src={BooksitoutImages.WebsiteLogo.aladin} />
				<ColSpacer size={2.5} />
				<p className={'m-0'}>{popularBook.otherRankings.aladin != null ? `${popularBook.otherRankings.aladin}위` : '-'}</p>
			</div>
			<ColSpacer size={5} />

			<div className={`d-flex ${justify} align-items-center force-1-line`} style={{ width: '70px' }}>
				<Logo src={BooksitoutImages.WebsiteLogo.yes24} />
				<ColSpacer size={2.5} />
				<p className={'m-0'}>{popularBook.otherRankings.yes24 != null ? `${popularBook.otherRankings.yes24}위` : '-'}</p>
			</div>
			<ColSpacer size={5} />

			<div className={`d-flex ${justify} align-items-center force-1-line`} style={{ width: '70px' }}>
				<Logo src={BooksitoutImages.WebsiteLogo.kyobo} />
				<ColSpacer size={2.5} />
				<p className={'m-0'}>{popularBook.otherRankings.kyobo != null ? `${popularBook.otherRankings.kyobo}위` : '-'}</p>
			</div>
			<ColSpacer size={5} />
		</div>
	)
}

const Row = styled.div`
	position: relative;
	display: flex;
	width: 100%;
`

const GlowCard = styled.div<{ status: BookStatus }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 8px;
	height: 100%;
	background: linear-gradient(90deg, ${props => (props.status == 'NOT_ADDED' ? 'none' : props.status == 'GIVE_UP' ? '#ef4444' : '#22c55e')} 0%, ${props => (props.status == 'NOT_ADDED' ? '#9ca3af' : props.status == 'GIVE_UP' ? '#ef4444' : '#22c55e')} 70%, transparent 100%);
	z-index: 1;
`

const ClickableOverlay = styled.div<{ clickable: boolean }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 10%;
	height: 100%;
	z-index: 10;
	cursor: ${props => (props.clickable ? 'pointer' : 'default')};
`

const CoverContainer = styled.div`
	min-width: 75px;
	max-width: 75px;
	justify-content: center;
	text-align: center;
`

interface CoverProps {
	src: string | null
}

const Cover = styled.img.attrs({
	className: 'img-fluid rounded',
})<CoverProps>`
	height: 90px;
`

const Title = styled.h5.attrs({
	className: 'clamp-1-line',
})``

const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;

	max-width: calc(100% - 100px);
`

const RankingBadge = styled.div`
	right: 0;
	min-width: 25px;
	height: 25px;
	background-color: ${ColorConfig.Primary};
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 25px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const Logo = styled.img`
	width: 25px;
	height: 25px;
	border-radius: 6px;
`

export default PopularBookListRow
